import {instance} from "./";

export const getPersonsList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/person"
  });
  return response;
};

export const getPersonCard = id => {
  const response = instance({
    method: "get",
    url: `/work/api/person/${id}/card`
  });
  return response;
};

export const getPersonFullInfo = id => {
  const response = instance({
    method: "get",
    url: `/work/api/person/${id}`
  });
  return response;
};

export const getPersonHistory = id => {
  const response = instance({
    method: "get",
    url: `/work/api/person/${id}/event`
  });
  return response;
};

export const getSystemInfo = id => {
  const response = instance({
    method: "get",
    url: `/work/api/person/${id}/system`
  });
  return response;
};

export const getPersonDocument = id => {
  const response = instance({
    method: "get",
    url: `/work/api/person/${id}/main/document`
  });
  return response;
};

export const getPersonDocumentAttachments = id => {
  return instance({
    method: "get",
    url: `/work/api/person/${id}/main/document/attachment`
  });
};

export const getPersonSnilsAttachments = id => {
  return instance({
    method: "get",
    url: `/work/api/person/${id}/snils/document/attachment`
  });
};

export const getPersonRoles = id => {
  return instance({
    method: "get",
    url: `/work/api/person/${id}/system/role`
  });
};

export const getPersonWorldSkills = id => {
  return instance({
    method: "get",
    url: `/work/api/person/${id}/profession/world-skill`
  });
};

export const getPersonSkills = id => {
  return instance({
    method: "get",
    url: `/work/api/person/${id}/profession/skill-state`
  });
};

export const getPersonOrganizations = id => {
  return instance({
    method: "get",
    url: `/work/api/person/${id}/profession/organization`
  });
};

export const createPerson = data => {
  return instance({
    method: "post",
    url: `/work/api/person`,
    data
  });
};

export const importPersons = data => {
  console.log(data);
  const response = instance({
    method: "post",
    url: `/work/api/person/rpc`,
    data
  });
  return response;
};

export const deletePerson = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/person/${id}`
  });
  return response;
};

export const addPersonAttachment = (id, fileId) => {
  const data = new FormData();
  data.set('attachment', fileId);

  const response = instance({
    method: "post",
    url: `/work/api/person/${id}/main/document/attachment`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
  return response;
}

export const deletePersonAttachment = (id, fileId) => {
  return instance({
    method: "delete",
    url: `/work/api/person/${id}/main/document/attachment/${fileId}`
  });
};

export const addPersonSnilsAttachment = (id, fileId) => {
  const data = new FormData();
  data.set('attachment', fileId);

  return instance({
    method: "post",
    url: `/work/api/person/${id}/snils/document/attachment`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

export const deletePersonSnilsAttachment = (id, fileId) => {
  return instance({
    method: "delete",
    url: `/work/api/person/${id}/snils/document/attachment/${fileId}`
  });
};

export const updatePerson = (id, savedata) => {
  const wsIds = savedata.worldSkills ? savedata.worldSkills.map((ws) => ws.id) : null;
  const skilIds = savedata.skillStates ? savedata.skillStates.map((ws) => ws.id) : null;

  const data = {
    main: savedata.main,
    document: savedata.document,
    worldSkills: wsIds,
    skillStates: skilIds
  };

  return instance({
    method: "put",
    url: `/work/api/person/${id}`,
    data
  });
};

export const updatePersonRoles = (id, rolelist) => {
  const data = {
    type : "change-roles",
    id : id,
    roles : rolelist
  };

  const response = instance({
    method: "post",
    url: `/work/api/person/rpc`,
    data
  });
  return response;
};

export const updateAvatar = (id, file) => {
  const data = new FormData();
  data.set('avatar', file, file.name);

  const response = instance({
    method: "post",
    url: `/work/api/person/${id}/avatar`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data
  });
  return response;
};

export const blockPerson = (id, type) => {
  const data = {
    type : type,
    id : id
  };

  const response = instance({
    method: "post",
    url: `/work/api/person/rpc`,
    data
  });
  return response;
};

export const getMunicipalsList = (regionId) => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/municipal?regionId=${regionId}`
  });
  return response;
};

export const getOrganizationsList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/organization?mode=select"
  });
  return response;
};

/*export const getPostsList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/dict/post"
  });
  return response;
};*/

export const getDepartments = id => {
  const response = instance({
    method: "get",
    url: `/work/api/organization/${id}/department`
  });
  return response;
};

export default {
  getPersonsList,
  getPersonCard,
  getPersonFullInfo,
  getPersonHistory,
  getPersonDocument,
  getPersonDocumentAttachments,
  deletePersonAttachment,
  addPersonAttachment,
  getPersonSnilsAttachments,
  addPersonSnilsAttachment,
  deletePersonSnilsAttachment,
  getPersonRoles,
  getPersonSkills,
  getPersonWorldSkills,
  getPersonOrganizations,
  createPerson,
  deletePerson,
  updatePerson,
  updatePersonRoles,
  importPersons,
  blockPerson,
  getMunicipalsList,
  getOrganizationsList,
  getDepartments,
  //getPostsList,
  getSystemInfo,
  updateAvatar
};
